import { useMutation } from '@tanstack/react-query';

import { deletePost } from './post-service';

export function useDeletePost() {
  return useMutation({
    mutationFn: deletePost,
  });
}
